(function () {

    'use strict';

    angular.module('FotocApp')

    .component('transform', {
         
        templateUrl: (USE_TEMPLATE_CACHE ? '' :  window.BASE_PATH  + '../../src/') + 'editor/tools/transform.component.html',
        bindings: {},
        controller: ['$rootScope', '$element','$editorService','$canvasService', '$lang', '$scope', function ($rootScope, $element, $editorService, $canvasService, $lang,  $scope) {

            var self = this;
            
            this.$canvasService = $canvasService;
            this.$editorService = $editorService;
            $scope.$lang = $lang;
            var scaleSlider_div;
            var rotateSlider_div;

            this.$onInit = function () {  
           
               scaleSlider_div = angular.element($element).find('.scale-slider')[0];
               rotateSlider_div = angular.element($element).find('.rotate-slider')[0];


               $editorService.ui.slidersDivs.rotation = rotateSlider_div;
               $editorService.ui.slidersDivs.scale = scaleSlider_div;

               // scale 
               noUiSlider
               .create(scaleSlider_div, {
                    start: [1],
                    range: {
                        'min': 1,
                        'max': 3
                    }      
                })
                .on('update', doUpdateEscala);


                // rotate 
                noUiSlider
                .create(rotateSlider_div, {
                     start: [0],
                     range: {
                         'min': -180,
                         'max': 180
                     }      
                 })
                 .on('update', doUpdateRotate);
            
                
                $rootScope.$watch('$editorService.ui.editingItem', update);

                


            }

            this.refresh = function(){
                $canvasService.refreshPositionEditingItem();
                setTimeout(function(){$scope.$apply()},10);
            }
            function update(){

                try{
                    scaleSlider_div.noUiSlider.set([$editorService.data.images[ $editorService.ui.editingItem].position.scaleX]);
                    rotateSlider_div.noUiSlider.set([$editorService.data.images[ $editorService.ui.editingItem].position.rotation]);
                }catch(e){

                }
              
            }

            function doUpdateRotate(value){
                
              $canvasService.setManualRotateToEditingTransformable(parseFloat(value))
              
            }

            function doUpdateEscala(value){

                $canvasService.setManualScaleToEditingTransformable(parseFloat(value))
              
            }

 

        }]
        
        
    })

})(); 